import React from "react";
import {
  CheckCircleOutlined,
  ExclamationCircleOutlined, EyeInvisibleOutlined,
  EyeOutlined,
  StopOutlined,
  SwitcherOutlined
} from "@ant-design/icons";
import { Tag } from "antd";
import { StickerPackInterface } from "../../../../store/sticker_maker/stickerPacksSlice";
import { useAppSelector } from "../../../../store/hooks";

interface TagsInterface {
  category_ids: StickerPackInterface['category_ids'];
}

export const StatusTag = ({ status } : { status: number }) => {
  switch (status) {
    case 0:
      return <Tag color='warning' icon={<ExclamationCircleOutlined />}>in review</Tag>;
    case 1:
      return <Tag color='success' icon={<CheckCircleOutlined />}>reviewed</Tag>;
    case 2:
      return <Tag color='error' icon={<StopOutlined />}>blocked</Tag>;
  }

  return <Tag color='default' icon={<SwitcherOutlined />}>unknown</Tag>;
}

export const PublishedTag = ({ published } : { published: boolean }) => {
  if (published) {
    return <Tag color='processing' icon={<CheckCircleOutlined />}>published</Tag>;
  }

  return <Tag color='default' icon={<StopOutlined />}>unpublished</Tag>;
}

export const ActiveTag = ({ active } : { active: boolean }) => {
  if (active) {
    return <Tag color='success' icon={<EyeOutlined />}>active</Tag>;
  }

  return <Tag color='default' icon={<EyeInvisibleOutlined />}>inactive</Tag>;
}

export const Tags = ({ category_ids } : TagsInterface) => {
  const categories = useAppSelector(state => state.stickerMaker.categories.entities);

  const renderTag = (id: number) => {
    const category = categories[id];

    if (!category) {
      return null;
    }

    return (
      <Tag key={category.id} color={category.color || 'default'}>
        {category.name}
      </Tag>
    )
  }

  return (
    <>
      {category_ids.map(renderTag)}
    </>
  )
}
